var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.size]: true,
    'h5-price-size-wrap': _vm.isH5,
    'price-size-wrap': !_vm.isH5,
  }},[(_vm.activePrice && _vm.originPrice)?[_c('div',{staticClass:"active-price price",domProps:{"innerHTML":_vm._s(_vm.splitPrice(_vm.activePrice))}}),_c('div',{staticClass:"origin-price price",domProps:{"innerHTML":_vm._s(_vm.splitPrice(_vm.originPrice))}})]:(_vm.originPrice)?[_c('div',{staticClass:"active-price price",domProps:{"innerHTML":_vm._s(_vm.splitPrice(_vm.originPrice))}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }